<template>
  <div>
    <template v-if="existTest && !loading && !pdfMode">
			<v-tabs class="text-caption" height="30" v-model="tab">
				<v-tab class="text-caption" v-if="generalTests.length > 0" href="#vital-signs"><translate>Vital Signs</translate></v-tab>
				<v-tab class="text-caption" v-if="bodyStructureTests.length > 0" href="#body-structure"><translate>Body Structure</translate></v-tab>
				<v-tab class="text-caption" v-if="tongueTests.length > 0" href="#tongue"><translate>Tongue</translate></v-tab>
				<v-tab class="text-caption" v-if="abdominalPalpationTests.length > 0" href="#abdominal-palpation"><translate>Abdominal Palpation</translate></v-tab>
				<v-tab class="text-caption" v-if="pulseTests.length > 0" href="#pulse"><translate>Pulse</translate></v-tab>
				<v-tab class="text-caption" v-if="ryodorakuTests.length > 0" href="#ryodoraku">Ryodoraku</v-tab>
				<v-tab class="text-caption" v-if="osteoTests.length > 0" href="#osteo"><translate>Osteopathy</translate></v-tab>
				<v-tab v-for="customTest in customTests" :key="customTest.id" class="text-caption" :href="'#' + customTest.id + customTest.name">{{customTest.name}}</v-tab>
			</v-tabs>
			<v-tabs-items v-model="tab">
				<v-tab-item v-if="generalTests.length > 0" :transition="false" :reverse-transition="false" value="vital-signs">
					<v-window show-arrows>
						<v-window-item v-for="t in generalTests" no-gutters :key="t.id">
							<VitalSignsForm
								:test="t.result"
								:results="true"
								:clinic="true"
							/>
							<v-row v-if="importOption" no-gutters>
								<v-btn color="secondary" depressed small class="ml-2 mb-1 float-right primary--text" @click="$emit('import-test', appointment.id, t.id, false)" :disabled="loadingImportTest">
									<v-icon class="mr-1" small>mdi-calendar-import</v-icon>
									<translate>Import</translate><span class="ml-1" v-translate>Vital Signs</span>
								</v-btn>
							</v-row>
						</v-window-item>
					</v-window>
				</v-tab-item>
				<v-tab-item v-if="bodyStructureTests.length > 0" :transition="false" :reverse-transition="false" value="body-structure">
					<v-window show-arrows>
						<v-window-item v-for="t in bodyStructureTests" no-gutters :key="t.id">
							<v-row no-gutters>
								<div style="white-space: pre-wrap;" class="ma-3">{{t.result.note}}</div>
							</v-row>
							<v-row v-if="importOption" no-gutters>
								<v-btn color="secondary" depressed small class="ml-2 mb-1 float-right primary--text" @click="$emit('import-test', appointment.id, t.id, false)" :disabled="loadingImportTest">
									<v-icon class="mr-1" small>mdi-calendar-import</v-icon>
									<translate>Import</translate><span class="ml-1" v-translate>Body Structure</span>
								</v-btn>
							</v-row>
						</v-window-item>
					</v-window>
				</v-tab-item>
				<v-tab-item v-if="tongueTests.length > 0" :transition="false" :reverse-transition="false" value="tongue">
					<v-window show-arrows>
						<v-window-item v-for="t in tongueTests" no-gutters :key="t.id">
							<v-row no-gutters align="center" class="pa-2">
								<v-col>
									<v-row no-gutters align="center">
										<v-col md="auto" class="mr-4">
											<TongueTemplate
												:test="t.data"
											/>
										</v-col>
										<v-col>
											<TongueDetails :tongue="t.data" />
										</v-col>
									</v-row>
								</v-col>
								<v-col md="auto" v-if="t.data.photos.length > 0">
									<v-carousel
										height="120"
										style="width: 180px"
										hide-delimiter-background
										show-arrows-on-hover
										:show-arrows="t.data.photos.length > 1"
										hide-delimiters
									>
										<v-carousel-item
											v-for="(image, i) in t.data.photos"
											:key="i"
										>
											<v-img
												v-if="image.blob"
												:src="image.url"
												height="100"
												contain
											/>
											<v-img
												v-else
												:src="image.image"
												height="100"
												contain
											/>
										</v-carousel-item>
									</v-carousel>
								</v-col>
							</v-row>
							<v-row v-if="importOption" no-gutters>
								<v-btn color="secondary" depressed small class="ml-2 mb-1 float-right primary--text" @click="$emit('import-test', appointment.id, t.id, false)" :disabled="loadingImportTest">
									<v-icon class="mr-1" small>mdi-calendar-import</v-icon>
									<translate>Import</translate><span class="ml-1" v-translate>Tongue</span>
								</v-btn>
							</v-row>
						</v-window-item>
					</v-window>
				</v-tab-item>
				<v-tab-item v-if="abdominalPalpationTests.length > 0" :transition="false" :reverse-transition="false" value="abdominal-palpation">
					<v-window show-arrows>
						<v-window-item v-for="t in abdominalPalpationTests" no-gutters :key="t.id">
							<v-row no-gutters>
								<div style="white-space: pre-wrap;" class="ma-3">{{t.result.note}}</div>
							</v-row>
							<v-row v-if="importOption" no-gutters>
								<v-btn color="secondary" depressed small class="ml-2 mb-1 float-right primary--text" @click="$emit('import-test', appointment.id, t.id, false)" :disabled="loadingImportTest">
									<v-icon class="mr-1" small>mdi-calendar-import</v-icon>
									<translate>Import</translate><span class="ml-1" v-translate>Abdominal Palpation</span>
								</v-btn>
							</v-row>
						</v-window-item>
					</v-window>
				</v-tab-item>
				<v-tab-item v-if="pulseTests.length > 0" :transition="false" :reverse-transition="false" value="pulse">
					<v-window show-arrows>
						<v-window-item v-for="t in pulseTests" no-gutters :key="t.id">
							<TCMPulseDetails :test="t" />
							<v-row v-if="importOption" no-gutters>
								<v-btn color="secondary" depressed small class="ml-2 mb-1 float-right primary--text" @click="$emit('import-test', appointment.id, t.id, false)" :disabled="loadingImportTest">
									<v-icon class="mr-1" small>mdi-calendar-import</v-icon>
									<translate>Import</translate><span class="ml-1" v-translate>Pulse</span>
								</v-btn>
							</v-row>
						</v-window-item>
					</v-window>
				</v-tab-item>
				<v-tab-item v-if="ryodorakuTests.length > 0" :transition="false" :reverse-transition="false" value="ryodoraku">
					<v-window show-arrows>
						<v-window-item v-for="t in ryodorakuTests" :key="t.id">
							<RyodorakuResults
								:data="t.result"
								:clinic="true"
								:showGCharts="true"
							/>
						</v-window-item>
					</v-window>
				</v-tab-item>
				<v-tab-item v-if="osteoTests.length > 0" :transition="false" :reverse-transition="false" value="osteo">
					<v-window show-arrows>
						<v-window-item v-for="t in osteoTests" :key="t.id">
							<OsteopathyDetails :test="t.data" />
							<v-row v-if="importOption" no-gutters>
								<v-btn color="secondary" depressed small class="ml-2 mb-1 float-right primary--text" @click="$emit('import-test', appointment.id, t.id, false)" :disabled="loadingImportTest">
									<v-icon class="mr-1" small>mdi-calendar-import</v-icon>
									<translate>Import</translate><span class="ml-1" v-translate>Osteopathy</span>
								</v-btn>
							</v-row>
						</v-window-item>
					</v-window>
				</v-tab-item>
				<v-tab-item v-for="customTest in customTests" :key="customTest.id" :transition="false" :reverse-transition="false" :value="customTest.id + customTest.name">
					<v-window show-arrows>
						<v-window-item>
							<CustomTestForm
								:test="customTest"
								:results="true"
								:clinic="true"
							/>
							<v-row v-if="importOption" no-gutters>
								<v-btn color="secondary" depressed small class="ml-2 mb-1 float-right primary--text" @click="$emit('import-test', appointment.id, customTest.id, true)" :disabled="loadingImportTest">
									<v-icon class="mr-1" small>mdi-calendar-import</v-icon>
									<translate>Import</translate><span class="ml-1">{{customTest.name}}</span>
								</v-btn>
							</v-row>
						</v-window-item>
					</v-window>
				</v-tab-item>
			</v-tabs-items>
		</template>
		<template v-else-if="existTest && !loading && pdfMode">
			<v-row v-if="generalTests.length > 0" no-gutters>
				<v-col cols="12" class="font-weight-medium"><translate>Vital Signs</translate></v-col>
				<v-col cols="12" v-for="t in generalTests" :key="t.id">
					<VitalSignsForm
						:test="t.result"
						:results="true"
						:clinic="true"
					/>
				</v-col>
			</v-row>
			<v-row v-if="bodyStructureTests.length > 0" no-gutters>
				<v-col cols="12" class="font-weight-medium"><translate>Body Structure</translate></v-col>
				<v-col cols="12" v-for="t in bodyStructureTests" no-gutters :key="t.id">
					<v-row no-gutters>
						<div style="white-space: pre-wrap;" class="ma-3">{{t.result.note}}</div>
					</v-row>
				</v-col>
			</v-row>
			<v-row v-if="tongueTests.length > 0" no-gutters>
				<v-col cols="12" class="font-weight-medium"><translate>Tongue</translate></v-col>
				<v-col cols="12" v-for="t in tongueTests" no-gutters :key="t.id">
					<v-row no-gutters align="center" class="pa-2">
						<v-col>
							<v-row no-gutters align="center">
								<v-col md="auto" class="mr-4">
									<TongueTemplate
										:test="t.data"
									/>
								</v-col>
								<v-col>
									<TongueDetails :tongue="t.data" />
								</v-col>
							</v-row>
						</v-col>
						<v-col md="auto" v-if="t.data.photos.length > 0">
							<v-carousel
								height="120"
								style="width: 180px"
								hide-delimiter-background
								show-arrows-on-hover
								:show-arrows="t.data.photos.length > 1"
								hide-delimiters
							>
								<v-carousel-item
									v-for="(image, i) in t.data.photos"
									:key="i"
								>
									<v-img
										v-if="image.blob"
										:src="image.url"
										height="100"
										contain
									/>
									<v-img
										v-else
										:src="image.image"
										height="100"
										contain
									/>
								</v-carousel-item>
							</v-carousel>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
			<v-row v-if="abdominalPalpationTests.length > 0" no-gutters>
				<v-col cols="12" class="font-weight-medium"><translate>Abdominal Palpation</translate></v-col>
				<v-col cols="12" v-for="t in abdominalPalpationTests" no-gutters :key="t.id">
					<v-row no-gutters>
						<div style="white-space: pre-wrap;" class="ma-3">{{t.result.note}}</div>
					</v-row>
				</v-col>
			</v-row>
			<v-row v-if="pulseTests.length > 0" no-gutters>
				<v-col cols="12" class="font-weight-medium"><translate>Pulse</translate></v-col>
				<v-col cols="12" v-for="t in pulseTests" no-gutters :key="t.id">
					<TCMPulseDetails :test="t" />
				</v-col>
			</v-row>
			<v-row v-if="ryodorakuTests.length > 0" no-gutters>
				<v-col cols="12" class="font-weight-medium">Ryodoraku</v-col>
				<v-col cols="12" v-for="t in ryodorakuTests" :key="t.id">
					<RyodorakuResults
						:data="t.result"
						:clinic="true"
						:showGCharts="true"
					/>
				</v-col>
			</v-row>
			<v-row v-if="osteoTests.length > 0" no-gutters>
				<v-col cols="12"><translate>Osteopathy</translate></v-col>
				<v-col cols="12" v-for="t in osteoTests" :key="t.id">
					<OsteopathyDetails :test="t.data" />
				</v-col>
			</v-row>
			<v-row v-for="customTest in customTests" :key="customTest.id" no-gutters>
				<v-col cols="12" class="font-weight-medium">{{customTest.name}}</v-col>
				<v-col cols="12">
					<CustomTestForm
						:test="customTest"
						:results="true"
						:clinic="true"
						:pdfMode="pdfMode"
					/>
				</v-col>
			</v-row>
		</template>
		<p v-else class="font-weight-thin ml-2" v-translate key="no-tests">No tests performed.</p>
  </div>
</template>

<script>
import RyodorakuResults from "@/components/appointment/tests/ryodoraku/RyodorakuResults.vue";
import VitalSignsForm from "@/components/appointment/tests/general/VitalSignsForm.vue";
import CustomTestForm from "@/components/appointment/tests/custom/CustomTestForm.vue";
import TongueTemplate from "@/components/drawing/TongueTemplate.vue";
import TongueDetails from "@/components/drawing/TongueDetails.vue";
import TCMPulseDetails from '@/components/appointment/tests/tcm/TCMPulseDetails.vue';
import OsteopathyDetails from '@/components/appointment/tests/osteo/OsteopathyDetails.vue';

export default {
  name: "ClinicHistoryTests",
  props: ["appointment", "loading", "importOption", "loadingImportTest", "pdfMode"],
  components: {
    RyodorakuResults,
    VitalSignsForm,
    CustomTestForm,
    TongueTemplate,
    TongueDetails,
		TCMPulseDetails,
    OsteopathyDetails
  },
  data: () => ({
    tab: null
  }),
  computed: {
    ryodorakuTests() {
			return this.appointment.tests.filter(t => t.module == 'ryodoraku');
		},
		tongueTests() {
			return this.appointment.tests.filter(t => t.module == 'tcm' && t.kind == 'tongue');
		},
		pulseTests() {
			return this.appointment.tests.filter(t => t.module == 'tcm' && t.kind == 'pulse');
		},
		bodyStructureTests() {
			return this.appointment.tests.filter(t => t.module == 'tcm' && t.kind == 'body-structure');
		},
		abdominalPalpationTests() {
			return this.appointment.tests.filter(t => t.module == 'tcm' && t.kind == 'abdominal-palpation');
		},
		generalTests() {
			return this.appointment.tests.filter(t => t.module == 'general');
		},
		osteoTests() {
			return this.appointment.tests.filter(t => t.module == 'osteo');
		},
		customTests() {
			//return this.appointment.custom_tests.filter(t => t.test);
			return this.appointment.custom_tests;
		},
    existTest() {
			return this.ryodorakuTests.length > 0 ||
							this.tongueTests.length > 0 ||
							this.pulseTests.length > 0 ||
							this.bodyStructureTests.length > 0 ||
							this.abdominalPalpationTests.length > 0 ||
							this.generalTests.length > 0 ||
							this.customTests.length > 0;
		}
  }
}
</script>